import { MeiliSearchError } from "./meilisearch-error.js";
/** Error thrown when a waiting for a task times out. */
export class MeiliSearchTaskTimeOutError extends MeiliSearchError {
    name = "MeiliSearchTaskTimeOutError";
    cause;
    constructor(taskUid, timeout) {
        super(`timeout of ${timeout}ms has exceeded on task ${taskUid} when waiting for it to be resolved.`);
        this.cause = { taskUid, timeout };
    }
}
//# sourceMappingURL=meilisearch-task-timeout-error.js.map